import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getRetailersList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getRetailerDetails();
  });
};

export const getRetailerDetails = (): TListItem => {
  const accountStatuses = ['active', 'inactive'];
  return {
    id: faker.datatype.uuid(),
    name: faker.name.findName(),
    account_status: (faker.helpers as any).arrayElement(accountStatuses),
    overall_volume: faker.finance.amount(1000, 10000, 2),
    monthly_volume: faker.finance.amount(1000, 10000, 2),
    pending_invoice: faker.finance.amount(1000, 10000, 2),
    invoice_fiat_code: faker.finance.currencyCode(),
    last_invoice: faker.date.recent().toISOString(),
  } as TListItem;
};
